import * as React from 'react';
import { BooleanFilter } from '../../Filter/BooleanFilter';
import { CheckboxFilter } from '../../Filter/CheckboxFilter';
import { DropdownFilter } from '../../Filter/DropdownFilter';
import { Trans } from '../../Trans';
import { AbstractFilterSectionView, FilterSectionViewProps } from '../AbstractFilterSectionView';
import { FilterInfo } from '../FilterInfo';

interface FilterViewProps extends FilterSectionViewProps {
}

export class ElectronicsFilterView extends AbstractFilterSectionView<FilterViewProps> {
    public render() {
        return <div className="pf-filter-container">
            <div className="pf-filter-section">
                <div className="row">
                    <div className="pf-filter-wrapper">
                        <div className="pf-filter-header"><Trans>Schnittstelle</Trans></div>
                        <CheckboxFilter filter={this.getFilter('Feldbus')}
                                        options={this.collectAvailable('Feldbus')}
                                        onChange={this.handleChange}/>
                    </div>
                    <div className="pf-filter-wrapper">
                        <div className="pf-filter-header"><Trans>Eichfähig</Trans></div>
                        <BooleanFilter filter={this.getFilter('eichfaehig')}
                                       onChange={this.handleChange}/>
                    </div>
                    <div className="pf-filter-wrapper">
                        <div className="pf-filter-header"><Trans>Anzahl_Messrollen</Trans></div>
                        <DropdownFilter filter={this.getFilter('Anzahl_Messrollen')}
                                        onChange={this.handleChange}
                                        options={this.collectAvailable('Anzahl_Messrollen')}/>
                        {/*
                        <RangeSliderFilter filter={this.getFilter('Anzahl_Messrollen')}
                                           attr={('Anzahl_Messrollen')}
                                           onChange={this.handleChange}
                                           options={this.collectAvailable<number>('Anzahl_Messrollen')}/>
                        */}
                    </div>
                </div>
            </div>
            <FilterInfo {...this.props}/>
        </div>;
    }
}
